import React,{Component} from 'react'
import Link from 'react-router'
export default class ModalDel extends Component{
     render(){
        return (
            <div className="modal fade" id={this.props.id} tabIndex="-1" role="dialog"
					 aria-labelledby="myModalLabel" aria-hidden="true" style={{marginTop: "15%"}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close"
                                    data-dismiss="modal" aria-hidden="true">
                                &times;
                            </button>
                            <h4 className="modal-title">
                                <strong>{this.props.name==undefined?"删除":this.props.name}</strong>
                            </h4>
                        </div>
                        <div className="modal-body">
                            确定{this.props.name==undefined?"删除":this.props.name}?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default"
                                    data-dismiss="modal">关闭
                            </button> 
                            <button type="button" className="btn btn-info" data-dismiss="modal"
                                onClick={this.props.delModSure}>确定
                            </button> 
                        </div>
                    </div>
                </div>
            </div>
        )
     }
}
//<ModalDel delModSure={this.method} id=""/>


// WEBPACK FOOTER //
// ./modules/component/ModalDel.js